import type { LocalizedText } from '@up2d8/contracts';

/** Het label in de taal van de lezer, met terugval. Zelfde regel als op de server. */
export function labelOf(label: LocalizedText, language: string, fallback: string): string {
  const record = label as Record<string, string | undefined>;
  const first = Object.values(record).find((text) => text?.trim());
  return record[language]?.trim() || record.nl?.trim() || first?.trim() || fallback;
}
